import { ArcRotateCamera, Mesh, PointerEventTypes, Vector3 } from "@babylonjs/core";
import { Node } from "@babylonjs/core/node";
import PosterBoard from "./PosterBoard";
import WVCamera from "./WVCamera";

/**
 * This represents a script that is attached to a node in the editor.
 * Available nodes are:
 *      - Meshes
 *      - Lights
 *      - Cameas
 *      - Transform nodes
 * 
 * You can extend the desired class according to the node type.
 * Example:
 *      export default class MyMesh extends Mesh {
 *          public onUpdate(): void {
 *              this.rotation.y += 0.04;
 *          }
 *      }
 * The function "onInitialize" is called immediately after the constructor is called.
 * The functions "onStart" and "onUpdate" are called automatically.
 */
export default class WVTarget extends Mesh {
    private _target:Vector3 = null;
    private _speed:number = 2;
    private _camera:ArcRotateCamera = null;
    private _wvc:WVCamera = null;

    /**
     * Override constructor.
     * @warn do not fill.
     */
    // @ts-ignore ignoring the super call as we don't want to re-init
    protected constructor() { }

    /**
     * Called on the node is being initialized.
     * This function is called immediatly after the constructor has been called.
     */
    public onInitialize(): void {
    }

    /**
     * Called on the scene starts.
     */
    public onStart(): void {
        var scene = this.getScene();
        let self = this;
        this._camera = scene.activeCamera as ArcRotateCamera;
        this._camera.setTarget(this);
        this._wvc = this._camera as WVCamera;

        //如果点到物体
        scene.onPointerObservable.add((pointerInfo) => {
            switch (pointerInfo.type) {
              case PointerEventTypes.POINTERDOWN:
                //console.log("POINTER DOWN");
                break;
              case PointerEventTypes.POINTERUP:
                //console.log("POINTER UP");
                break;
              case PointerEventTypes.POINTERMOVE:
                //console.log("POINTER MOVE");
                break;
              case PointerEventTypes.POINTERWHEEL:
                //console.log("POINTER WHEEL");
                break;
              case PointerEventTypes.POINTERPICK:
                //console.log("POINTER PICK");
                moveToTarget();
                break;
              case PointerEventTypes.POINTERTAP:
                //console.log("POINTER TAP");
                break;
              case PointerEventTypes.POINTERDOUBLETAP:
                //console.log("POINTER DOUBLE-TAP");
                focusToTarget();
                break;
            }
          });
          //单击
          let moveToTarget=function(){
              var pickResult = scene.pick(scene.pointerX, scene.pointerY);
              
              if (pickResult.hit) {
                console.log(pickResult.pickedMesh.name.substring(0,3));
                  if(pickResult.pickedMesh.name.substring(0,6) == "Ground"){
                      //self._camera.setTarget(this);
                      console.log("点击了：",pickResult.pickedMesh.name,pickResult.pickedPoint);
                      self._target = pickResult.pickedPoint;
                      self._target.y += 2.7;
                      self.lookAt(self._target);
                      //self._camera.useFramingBehavior = true;
                  }else if(pickResult.pickedMesh.name.substring(0,3) == "展框组"){
                      //self._camera.setTarget(this);
                      self._target = pickResult.pickedPoint;
                      self.lookAt(self._target);                    
                      //self._wvc._focusToRadio = 3;
  
                      //目标动画
                      scene.beginAnimation(pickResult.pickedMesh, 0, 20, false,5);
                      //self._camera.radius =2;
                      //self._camera.useFramingBehavior = true;
                      
                      //加载高清海报
                        let poster:PosterBoard =  pickResult.pickedMesh as PosterBoard;
                        poster.loadHightImage();
                  }
                  // var diffX = pickResult.pickedPoint.x - box.position.x;
                  // var diffY = pickResult.pickedPoint.z - box.position.z;
                  // box.rotation.y = Math.atan2(diffX,diffY);			          
              }	
          }
          //双击
          let focusToTarget=function(){
              var pickResult = scene.pick(scene.pointerX, scene.pointerY);
              
              if (pickResult.hit) {
                console.log(pickResult.pickedMesh.name.substring(0,3));
                  if(pickResult.pickedMesh.name.substring(0,6) == "Ground"){
                      console.log("点击了：",pickResult.pickedMesh.name,pickResult.pickedPoint);
                      self._target = pickResult.pickedPoint;
                      self._target.y += 2.7;
                      self.lookAt(self._target);
                  }else if(pickResult.pickedMesh.name.substring(0,3) == "展框组"){
                      self._target = pickResult.pickedPoint;
                      self.lookAt(self._target);                    
                      self._wvc._focusToRadio = 3;
  
                      //目标动画
                      scene.beginAnimation(pickResult.pickedMesh, 0, 20, false,5);

                      //加载高清海报
                      let poster:PosterBoard =  pickResult.pickedMesh as PosterBoard;
                      poster.loadHightImage();
                  }   
              }	
          }


    }

    /**
     * Called each frame.
     */
    public onUpdate(): void {
      let deltaTime:number = this.getEngine().getDeltaTime() * 0.001;
        if(this._target){
            this.lookAt(this._target);
            let d = Vector3.Distance(this._target,this.position);
            if(d<=0.1){
                //this._camera.useFramingBehavior = false;
                //this.position = this._target;
                this._target = null;
            }else{              
              //this.movePOV(0,0,this._speed * deltaTime);
              this.locallyTranslate(Vector3.Forward().multiplyByFloats(this._speed,this._speed,this._speed));
            }
        }
    }

    /**
     * Called on the object has been disposed.
     * Object can be disposed manually or when the editor stops running the scene.
     */
    public onStop(): void {
        // ...
    }

    /**
     * Called on a message has been received and sent from a graph.
     * @param message defines the name of the message sent from the graph.
     * @param data defines the data sent in the message.
     * @param sender defines the reference to the graph class that sent the message.
     */
    public onMessage(name: string, data: any, sender: any): void {
        switch (name) {
            case "myMessage":
                // Do something...
                break;
        }
    }
}
